module.exports = __webpack_public_path__ + "static/media/11.final.e15dfd51.mp4";